import { createStore } from 'redux';
import { IAppState } from './IAppState';
import { devToolsEnhancer, EnhancerOptions } from 'redux-devtools-extension';
import { reducer } from './reducer';
import { environment } from "../../environments/environment";

/* eslint-disable no-underscore-dangle */ 
export const store = createStore<IAppState>(reducer, /* preloadedState, */
    devToolsEnhancer({ trace: !environment.production } as EnhancerOptions));
/* eslint-enable */
